@if (showLogs) {
  <p-dialog
    [(visible)]="showLogs"
    [contentStyle]="{
      'max-height': '50em',
      width: 'auto',
      'z-index': '10030px'
    }"
    [closable]="false"
    [draggable]="false"
    position="center"
    showEffect="fade"
    [modal]="false"
    [style]="{ left: '10%', right: '10%' }"
    [draggable]="false"
    styleClass="error-modal">
    <ng-template
      #header
      class="ui-g"
      style="margin-top: -25px; border-bottom: 1px solid #d2d2d2">
      <div class="ui-g-11 log-title">View Logs</div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closePreview()"
        (keydown.enter)="closePreview()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <div class="ui-g error-detail">
      <div class="ui-g-12 error-box">
        @if (isPartner) {
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Duplicate Partner ID numbers:
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.duplicateMpnIdList) }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Partner Global ID:
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.vOrgIdList) }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Invalid Partner ID numbers:
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.invalidMpnIdList) }}
            </div>
          </div>
          <div class="ui-g margin-bottom">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Paid Facilitator Partner ID numbers:
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.paidFacilitatorMpnIdList) }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Duplicate Tenant ID(s):
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{
                getIdList(
                  fileImportLog?.tenantIdListImport?.duplicateTenantIdList
                )
              }}
            </div>
          </div>
          <div class="ui-g margin-bottom">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Invalid Tenant ID(s):
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{
                getIdList(
                  fileImportLog?.tenantIdListImport?.invalidTenantIdList
                )
              }}
            </div>
          </div>
        }
        @if (!isPartner && isTpidSupporetedForCustomer) {
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Duplicate TPID(s):
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.tpIdListImport?.duplicateTPIdList) }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1">
              Invalid TPID(s):
            </div>
            <div class="ui-g-8 ui-md-8 ui-lg-8">
              {{ getIdList(fileImportLog?.tpIdListImport?.invalidTPIdList) }}
            </div>
          </div>
        }
      </div>
    </div>
  </p-dialog>
}
